/**
 * Состав пака «tech-mint» (WEB-3718) — смысл групп и источник каждого числа:
 * `../stylePackComposition.ts`. Файл на пак, общий список `./index.ts`
 * собирается по каталогу (решение владельца 23.10 ~04:35).
 */
import type { StylePackComposition } from '../stylePack.types';

export const composition: StylePackComposition = {
  // 36 воронок: группы.json, группы 1, 9 (PACK в matrix.py)
  palettes: [
    // 6 из 36 воронок: palette → ближайшая тема по цветам
    { themeId: 'blue-gradient-light', weight: 0.17 },
    // 4 из 36 воронок: palette → ближайшая тема по цветам
    { themeId: 'slate-pro', weight: 0.11 },
    // 3 из 36 воронок: palette → ближайшая тема по цветам
    { themeId: 'study-blue', weight: 0.08 },
  ],
  fonts: [
    // 26 из 36 воронок: fontId
    { fontId: 'inter', weight: 0.72 },
    // 4 из 36 воронок: fontId
    { fontId: 'opensans', weight: 0.11 },
    // 4 из 36 воронок: fontId
    { fontId: 'poppins', weight: 0.11 },
  ],
  screenKinds: [
    // средняя доля экранов по 36 воронкам (признаки.json kinds) 0.372; сюда свёрнуты Q10, Q6, Q9 (замена из arsenal.mjs)
    { kind: 'Q1', share: 0.44 },
    // средняя доля экранов по 36 воронкам (признаки.json kinds) 0.090; сюда свёрнуты I2 (замена из arsenal.mjs)
    { kind: 'I1', share: 0.11 },
    // средняя доля экранов по 36 воронкам (признаки.json kinds) 0.083
    { kind: 'N1', share: 0.1 },
    // средняя доля экранов по 36 воронкам (признаки.json kinds) 0.071
    { kind: 'Q8', share: 0.08 },
    // средняя доля экранов по 36 воронкам (признаки.json kinds) 0.068; сюда свёрнуты Q7 (замена из arsenal.mjs)
    { kind: 'Q5', share: 0.08 },
    // средняя доля экранов по 36 воронкам (признаки.json kinds) 0.060; сюда свёрнуты Q3 (замена из arsenal.mjs)
    { kind: 'Q2', share: 0.07 },
    // средняя доля экранов по 36 воронкам (признаки.json kinds) 0.048
    { kind: 'N5', share: 0.06 },
    // средняя доля экранов по 36 воронкам (признаки.json kinds) 0.046
    { kind: 'N8', share: 0.05 },
  ],
  blocks: [
    // в 30 из 36 воронок (признаки.json blocks), подъём 1.85
    { type: 'multiple_choice', weight: 0.83, settings: {} },
    // в 36 из 36 воронок (признаки.json blocks), подъём 1.46; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): autoAdvance 447 из 550, optionIndicator 355 из 550
    {
      type: 'single_choice',
      weight: 1.0,
      settings: { autoAdvance: true, optionIndicator: 'none' },
    },
    // в 18 из 36 воронок (признаки.json blocks), подъём 2.22; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): autoAdvance 34 из 45
    { type: 'image_choice', weight: 0.5, settings: { autoAdvance: true } },
    // в 24 из 36 воронок (признаки.json blocks), подъём 1.66
    { type: 'email', weight: 0.67, settings: {} },
    // в 23 из 36 воронок (признаки.json blocks), подъём 1.33
    { type: 'loader_processing', weight: 0.64, settings: {} },
    // в 9 из 36 воронок (признаки.json blocks), подъём 3.27
    { type: 'micro_feedback', weight: 0.25, settings: {} },
    // в 11 из 36 воронок (признаки.json blocks), подъём 1.87
    { type: 'name_field', weight: 0.31, settings: {} },
  ],
  niches: [
    // 8 из 36 воронок (признаки.json theme)
    { niche: 'fitness', weight: 0.22 },
    // 5 из 36 воронок (признаки.json theme)
    { niche: 'beauty', weight: 0.14 },
    // 4 из 36 воронок (признаки.json theme)
    { niche: 'self_improvement', weight: 0.11 },
    // 3 из 36 воронок (признаки.json theme)
    { niche: 'meditation', weight: 0.08 },
  ],
};
